import React, { useEffect, useMemo, useState } from "react";
import { Radio } from "antd";
import IndexSelect from "../../../../components/FormControls/IndexSelect";
import { getModuleAdvancedSearchConfig } from "../../../../dataConfig";
import {
  handleSearchControl,
  handleSearchPage
} from "../../../../routes/Search";
import {
  formatNumber,
  getRecentSearchQuery,
  getUrlParams,
  getWindowWidth,
  isMobileScreen,
  isObject,
  stringifyURI
} from "../../../../services";
import { filterGroupsByCondition, getHiddenFieldNames, removeHiddenFields } from "../../../../utils/searchFilterConditions";
import styles from "./styles.scss";
import ModuleSearchControls from "../ModuleSearchControls";
import CollapseTitle from "../../../../components/SearchControls/SearchGroups/AllSearchControls/CollapseTitle";
import history from "../../../../history";
import {
  mapCategoryToHr
} from "../../../../routes/LanguageMapper";
import { QueryParam } from "../../../../models/enums";
import { LoadingFilterSection } from "../../SubLevel1/SubLevel1Desktop/LoadingFilterSection";

const showAllCategory = { module: "", name: "" };

const ModuleFilterSection = props => {
  const {
    selectedCategory,
    controls: groups,
    numberOfControls,
    categories,
    resetFields,
    normaliseSearchValues,
    location: { search },
  } = props;

  const [category, setCategory] = useState(selectedCategory);
  const [submitData, setSubmitData] = useState({ category: selectedCategory, ...getUrlParams(search, QueryParam.searchQuery) });
  const [showAllControls, setShowAllControls] = useState(false);

  const filteredGroups = useMemo(
    () => filterGroupsByCondition(groups, submitData),
    [groups, submitData]
  );

  useEffect(() => {
    selectedCategory && setSubmitData(getRecentSearchQuery(selectedCategory));
  }, [selectedCategory]);

  const openAllSearch = () => {
    setShowAllControls(true);
  };

  const closeAllSearch = () => {
    setShowAllControls(false);
  };

  useEffect(() => {
    const {
      selectedCategory,
      location: { search }
    } = props;
    //const selectedCategories = getSelectedCategories();

    //if (selectedCategories.length === 1) {
    //const { onCategoryChange, onSubmit } = props;
    //onCategoryChange(selectedCategories[0].name);
    //onSubmit({ category: selectedCategories[0].name }, false);
    //removed this line because of modules with one cat, for example: Tourism
    //}

    setCategory(selectedCategory);

    if (search && selectedCategory) {
      setSubmitData(prev => ({ ...prev, ...getRecentSearchQuery(selectedCategory) }));
    }
  }, [
    JSON.stringify(categories) != JSON.stringify([]),
    JSON.stringify(groups) != JSON.stringify([]),
    selectedCategory != "",
  ]);

  const handleSubmit = () => {
    const hiddenFields = getHiddenFieldNames(groups, submitData);
    const filteredData = removeHiddenFields(submitData, hiddenFields);
    props.onSubmit({ ...normaliseSearchValues(filteredData), category });
  };

  const resetFormFields = () => {
    setSubmitData({ category: selectedCategory });
  };

  const handleValuesChange = (values: any) => {
    let temp = {};

    isObject(values) &&
      Object.keys(values).forEach(key => {
        temp = { ...temp, ...values[key] };
      });

    setSubmitData(temp);
  };

  const handleCategoryChange = (value: any) => {
    const { onCategoryChange, module } = props;
    setSubmitData(prev => ({ ...prev, category: value }));
    // @ts-ignore
    setCategory(value);
    // *** Asynchronous function ***
    onCategoryChange(value, true);

    history.replace(
      `${mapCategoryToHr(value, module)}${stringifyURI({
        category: mapCategoryToHr(value, module)
      }, QueryParam.searchQuery, true)}`
    );
  };

  const handleFilteredCategoryChange = ({ target: { value } }) => {
    const { module } = value;

    module
      ? props.onSubmit({
        ...submitData,
        category: value.name,
        module: value.module
      })
      : props.onSubmit({
        ...submitData,
        category: value.name
      });
  };

  const renderFilteredCategories = () => {
    const { filteredCategories } = props;

    if (filteredCategories.length === 0) {
      return null;
    }

    return (
      <Radio.Group
        defaultValue={showAllCategory}
        // @ts-ignore
        onChange={handleFilteredCategoryChange}
        className={styles.filteredGroup}
      >
        <div className={styles.filteredModule}>
          <span>{"Kategorija"}</span>
          <Radio value={showAllCategory}>{"Prikaži sve"}</Radio>
        </div>
        {filteredCategories.map((m: any, index: any) => (
          <div key={index} className={styles.filteredModule}>
            <span>{m.moduleName}</span>
            {m.categories.map((c: any) => (
              <Radio key={`${c.name}_${c.module}`} value={c}>
                <span className="filtered-categories">{c.displayName}</span>(
                {formatNumber(c.count)})
              </Radio>
            ))}
          </div>
        ))}
      </Radio.Group>
    );
  };

  const getSelectedCategories = () => {
    const { categories, module } = props;
    const selectedCategories = categories.filter(
      (category: any) => category.moduleRoute === module
    );

    return selectedCategories;
  };

  const renderCategorySelector = () => {
    const selectedCategories = getSelectedCategories();

    if (selectedCategories.length === 1) {
      //return null;
      //removed this line because of modules with one cat, for example: Tourism
    }

    if (selectedCategories.length > 0) {
      return (
          <IndexSelect
            options={selectedCategories.map((c: any) => ({
              value: c.route,
              title: c.displayName
            }))}
            value={category || selectedCategory}
            onChange={handleCategoryChange}
          />
      );
    }

    return renderFilteredCategories();
  };

  const isMobile = isMobileScreen(getWindowWidth());

  return filteredGroups.length > 0 ? (
    <div className={isMobile ? styles.sectionContainerMobile : null}>
      <div className={isMobile ? styles.containerMobile : styles.container}>
        <ModuleSearchControls
          // @ts-ignore
          categories={categories}
          closeAllSearch={closeAllSearch}
          groups={filteredGroups}
          isMobile={isMobile}
          numberOfControls={numberOfControls}
          onSubmit={handleSubmit}
          onValuesChange={handleValuesChange}
          renderCategorySelector={renderCategorySelector}
          resetFormFields={resetFormFields}
          selectedCategory={selectedCategory}
          showAllControls={showAllControls}
          resetFields={resetFields}
          categoryHr={category || selectedCategory}
        />
      </div>
      {!showAllControls && filteredGroups.length > 1 && <CollapseTitle onClick={openAllSearch} />}
    </div>

  ) : (
    <div style={{ maxWidth: 1603, margin: "0 auto" }}>
      <LoadingFilterSection />
    </div>
  )

};

export default handleSearchPage(
  handleSearchControl(ModuleFilterSection, getModuleAdvancedSearchConfig)
);



// WEBPACK FOOTER //
// ./src/containers/ModulePage/ModuleSeaarchSection/ModuleFilterSection/index.tsx